import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { t } from '../../../utils/translations';

const ArticleFilters = ({ 
  filters, 
  onFiltersChange, 
  totalCount = 0, 
  filteredCount = 0,
  onClearFilters 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const categoryOptions = [
    { value: '', label: t('articles.allCategories') },
    { value: 'news', label: t('articles.news') },
    { value: 'events', label: t('articles.events') },
    { value: 'announcements', label: t('articles.announcements') }
  ];

  const statusOptions = [
    { value: '', label: t('articles.allStatus') },
    { value: 'published', label: t('articles.published') },
    { value: 'draft', label: t('articles.draft') },
    { value: 'scheduled', label: t('articles.scheduled') }
  ];

  const authorOptions = [
    { value: '', label: t('articles.allAuthors') },
    { value: 'admin', label: 'Admin User' },
    { value: 'editor1', label: 'Ahmad Hassan' },
    { value: 'editor2', label: 'Fatima Al-Zahra' },
    { value: 'editor3', label: 'Omar Khalil' }
  ];

  const languageOptions = [
    { value: '', label: t('articles.allLanguages') },
    { value: 'ar', label: 'العربية' },
    { value: 'en', label: 'English' },
    { value: 'tr', label: 'Türkçe' }
  ];

  const handleFilterChange = (key, value) => {
    onFiltersChange({
      ...filters,
      [key]: value
    });
  };

  const hasActiveFilters = Object.values(filters)?.some(value => 
    value && value !== '' && value !== 'all'
  );

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6 shadow-elevation-1">
      {/* Header Row */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2 space-x-reverse">
            <Icon name="Filter" size={20} className="text-muted-foreground" />
            <h3 className="text-sm font-medium text-foreground">{t('common.filters')}</h3>
          </div>
          
          {hasActiveFilters && (
            <div className="flex items-center space-x-2 space-x-reverse">
              <span className="text-xs text-muted-foreground">
                {filteredCount} {t('common.of')} {totalCount} {t('articles.articles')}
              </span>
              <Button
                variant="ghost"
                size="sm"
                onClick={onClearFilters}
                iconName="X"
                iconPosition="left"
                iconSize={14}
                className="text-xs h-6 px-2"
              >
                {t('common.clear')}
              </Button>
            </div>
          )}
        </div>

        <Button
          variant="ghost"
          size="sm"
          onClick={() => setIsExpanded(!isExpanded)}
          iconName={isExpanded ? 'ChevronUp' : 'ChevronDown'}
          iconPosition="right"
          iconSize={16}
          className="text-sm"
        >
          {isExpanded ? t('common.less') : t('common.more')} {t('common.filters')}
        </Button>
      </div>
      {/* Search Bar */}
      <div className="mb-4">
        <Input
          type="search"
          placeholder={t('articles.searchArticles')}
          value={filters?.search || ''}
          onChange={(e) => handleFilterChange('search', e?.target?.value)}
          className="max-w-md"
        />
      </div>
      {/* Quick Filter Chips */}
      <div className="flex flex-wrap gap-2 mb-4">
        {categoryOptions?.slice(1)?.map((category) => (
          <button
            key={category?.value}
            onClick={() => handleFilterChange('category', 
              filters?.category === category?.value ? '' : category?.value
            )}
            className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${
              filters?.category === category?.value
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted text-muted-foreground hover:bg-muted/80'
            }`}
          >
            {category?.label}
          </button>
        ))}
      </div>
      {/* Expanded Filters */}
      {isExpanded && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 pt-4 border-t border-border animate-slide-up">
          <Select
            label={t('common.status')}
            options={statusOptions}
            value={filters?.status || ''}
            onChange={(value) => handleFilterChange('status', value)}
          />

          <Select
            label={t('common.author')}
            options={authorOptions}
            value={filters?.author || ''}
            onChange={(value) => handleFilterChange('author', value)}
            searchable
          />

          <Select
            label={t('common.language')}
            options={languageOptions}
            value={filters?.language || ''}
            onChange={(value) => handleFilterChange('language', value)}
          />

          <div className="space-y-2">
            <label className="text-sm font-medium text-foreground">{t('common.dateRange')}</label>
            <div className="grid grid-cols-2 gap-2">
              <Input
                type="date"
                placeholder={t('common.from')}
                value={filters?.dateFrom || ''}
                onChange={(e) => handleFilterChange('dateFrom', e?.target?.value)}
              />
              <Input
                type="date"
                placeholder={t('common.to')}
                value={filters?.dateTo || ''}
                onChange={(e) => handleFilterChange('dateTo', e?.target?.value)}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ArticleFilters;